import CircularProgress from '@mui/material/CircularProgress'
import LinearProgress from '@mui/material/LinearProgress'

export const ProgressIndicator = ({ type = 'circular', ...restProps }) =>
  type === 'circular' ? <CircularProgress color="info" {...restProps} /> : <LinearProgress color="error" />
